import { Space } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { GreyInfoIcon, GreyText } from './styledComponent';

const Container = styled(Space)`
  border: 1px solid #d9d9d9;
  width: 100%;
  gap: 8px;
  height: 68px;
  padding: 12px;
`;

const StyledGreyInfoIcon = styled(GreyInfoIcon)`
  position: relative;
  top: -10px;
`;

const StyledGreyText = styled(GreyText)`
  display: block;
`;

const CopaymentDisclaimer = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Container>
      <StyledGreyInfoIcon />
      <div>
        <StyledGreyText>{t('benefits.coPaymentDisclaimerTitle')}</StyledGreyText>
        <StyledGreyText>{t('benefits.coPaymentDisclaimerDesc')}</StyledGreyText>
      </div>
    </Container>
  );
};

export default CopaymentDisclaimer;
